export default __webpack_public_path__ + "static/media/green-oval.fb2dc8d9.png";